export const HORIZONTAL_PADDING_SMALL = 3;
export const HORIZONTAL_PADDING_MEDIUM_UP = 5;
